import { User } from '@/types/user';

export const userHasScope = (user: User | null, scope: string): boolean => {
  if (!user || !user.permissions) {
    return false;
  }

  const [resource, scopeName] = scope.split(':');

  return user.permissions.some((permission) => permission.rsname === resource && permission.scopes.includes(scopeName));
};
